import { RootState } from 'handlers';

export const getYourContactData = ({ yourContact }: RootState) => yourContact;
